import { render } from "./TopBar.vue?vue&type=template&id=a3321b2c&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=a3321b2c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a3321b2c"

export default script